// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDGQoMS2de1K1W5sFQMtSF9uFefKNvEUoQ",
    authDomain: "electric-space-abbde.firebaseapp.com",
    databaseURL: "https://electric-space-abbde.firebaseio.com",
    storageBucket: "electric-space-abbde.appspot.com",
    projectId: "electric-space-abbde",
    messagingSenderId: "788821251092",
  },
  firebaseAdminConfig: {
    apiKey: "AIzaSyBCoef7O1E4PF6jXm4o_JRY2WdKezb8rhY",
    authDomain: "electric-space-admin.firebaseapp.com",
    databaseURL: "https://electric-space-admin.firebaseio.com",
    projectId: "electric-space-admin",
    storageBucket: "electric-space-admin.appspot.com",
    messagingSenderId: "784030203228",
    appId: "1:784030203228:web:7d51035e75ec27f1b49599"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
